export const DEFAULT_FOLIO_PREFIX = 'WD' as const;
